import React from 'react';
import {
  Box,
  Text,
  Input,
  Textarea,
  Select,
  Grid
} from '@chakra-ui/react';

export const CampaignDetails = ({ formData, setFormData }) => {

  // Clean handler that updates field and resets template in one call
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
      selectedTemplate: null
    }));
  };

  // If you need to update without resetting template
  const handleInputChangeOnly = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <Box className='box-style-card' mb={6}>
      <Box>
        <Text fontSize="xl" fontWeight="semibold" mb={6} color="gray.800">
          Campaign Details
        </Text>

        <Grid templateColumns="1fr 1fr" gap={6}>
          <Box>
            <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
              Campaign Name <span style={{ color: "red" }}>*</span>
            </Text>
            <Input
              placeholder="Enter campaign name"
              value={formData.campaignName || ''}
              onChange={(e) => handleInputChangeOnly('campaignName', e.target.value)}
              bg="gray.50"
              border="1px"
              borderColor="gray.200"
              _focus={{ borderColor: 'var(--brand-primary)', bg: 'white' }}
            />
          </Box>

          <Box>
            <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
              Campaign Type <span style={{ color: "red" }}>*</span>
            </Text>
            <Select
              placeholder="Select campaign type"
              value={formData.campaignType || ''}
              onChange={(e) => handleInputChange('campaignType', e.target.value)}
              bg="gray.50"
              border="1px"
              borderColor="gray.200"
              _focus={{ borderColor: 'var(--brand-primary)', bg: 'white' }}
            >
              <option value="3">Marketing</option>
              <option value="4">Informational</option>
            </Select>
          </Box>
        </Grid>

        <Box mt={6}>
          <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
            Description (Optional)
          </Text>
          <Textarea
            placeholder="Brief description of the campaign"
            value={formData.description || ''}
            onChange={(e) => handleInputChangeOnly('description', e.target.value)}
            bg="gray.50"
            border="1px"
            borderColor="gray.200"
            _focus={{ borderColor: 'var(--brand-primary)', bg: 'white' }}
            rows={4}
          />
        </Box>
      </Box>
    </Box>
  );
};